module.exports = __webpack_public_path__ + "img/get_into_game_industry_splash.ecb349d6.jpg";